export default __webpack_public_path__ + "static/media/eat.dce1d1d1.wav";